// src/pages/PrivacyPolicy.jsx
import React, { useEffect }  from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
  document.documentElement.style.scrollBehavior = "auto";
  window.scrollTo(0, 0);
}, []);


  return (
    <div className="legal-page">
      <div className="legal-hero">
        <button type="button" className="legal-back-btn" onClick={() => navigate(-1)}>
          ← Back
        </button>

        <div>
          <p className="legal-eyebrow">PayWeek Inc.</p>
          <h1>Privacy Policy</h1>
          <p className="legal-date">
            <strong>Effective Date:</strong> 10/5/2023
          </p>
        </div>
      </div>

      <main className="legal-container">
        <section>
          <p>
            PayWeek Inc. ("we", "our", or "us") provides payroll, accounting,
            invoicing, and financial management services for businesses. This
            Privacy Policy explains how we collect, use, disclose, and protect
            information when you use our website, mobile application, and related
            services.
          </p>
        </section>

        <section>
          <h2>1. Information We Collect</h2>
          <p>We may collect the following types of information:</p>

          <h3>Personal Information</h3>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Login and account information</li>
            <li>Business information</li>
          </ul>

          <h3>Payroll and Employee Information</h3>
          <ul>
            <li>Employee names and contact information</li>
            <li>Wage, salary, and payroll information</li>
            <li>Tax-related payroll details</li>
            <li>Benefit and deduction information</li>
            <li>Payroll history and payment records</li>
          </ul>

          <h3>Financial and Accounting Information</h3>
          <ul>
            <li>Bank account information made available through connected services</li>
            <li>Transaction history</li>
            <li>Account balances</li>
            <li>Accounting categories and financial reports</li>
            <li>Invoice and customer-related information</li>
          </ul>

          <h3>Device and Usage Information</h3>
          <ul>
            <li>Device type</li>
            <li>Operating system</li>
            <li>IP address</li>
            <li>App usage activity</li>
            <li>Log and diagnostic data</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Information</h2>
          <p>We use collected information to:</p>
          <ul>
            <li>Create and manage user accounts</li>
            <li>Provide payroll and accounting services</li>
            <li>Calculate payroll, deductions, and related amounts</li>
            <li>Display transactions and financial reports</li>
            <li>Generate invoices and business documents</li>
            <li>Verify accounts using SMS or other security methods</li>
            <li>Improve app performance and user experience</li>
            <li>Provide customer support</li>
            <li>Comply with legal and regulatory obligations</li>
          </ul>
        </section>

        <section>
          <h2>3. Third-Party Services</h2>
          <p>
            We may use trusted third-party service providers to operate certain
            parts of our services. These may include Plaid for secure financial
            account connectivity, Twilio for SMS verification and account security
            messages, and hosting, analytics, payment, or infrastructure providers.
          </p>
          <p>
            We do not store your online banking username or password. Financial
            account connections are handled through secure third-party providers.
          </p>
        </section>

        <section>
          <h2>4. Sharing of Information</h2>
          <p>
            We do not sell your personal information. We may share information only
            when necessary to provide our services, comply with law, prevent fraud,
            protect our rights, or work with trusted service providers.
          </p>
        </section>

        <section>
          <h2>5. Data Security</h2>
          <p>
            We use reasonable administrative, technical, and physical safeguards to
            protect your information. However, no method of transmission or storage
            is completely secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2>6. Data Retention and Disposal</h2>

<p>
  If a PayWeek account is closed or deactivated, we generally retain the
  account's information for one year following the date of account closure.
  After the one-year retention period, the information is deleted or anonymized
  unless we are required or permitted to retain it for a longer period under
  applicable law.
</p>

<p>
  Certain records, including payroll, tax, employment, accounting, transaction,
  and other financial records, may be retained for longer periods when required
  by applicable federal, state, or local laws and regulations.
</p>

<p>
  We may also retain information when reasonably necessary to comply with legal
  obligations, resolve disputes, prevent fraud, maintain security, enforce our
  agreements, or establish, exercise, or defend legal claims.
</p>

<p>
  When information is no longer required under our retention requirements, we
  take reasonable measures to securely delete, anonymize, or otherwise dispose
  of the information.
</p>

<p>
  Information contained in system backups may remain until the applicable
  backup retention cycle expires, after which it is deleted or overwritten in
  accordance with our backup procedures.
</p>
        </section>

        <section>
          <h2>7. Your Choices and Rights</h2>
          <p>
            Depending on your location, you may have rights to access, correct,
            update, or request deletion of certain personal information. You may
            contact us to make such a request.
          </p>
        </section>

        <section>
          <h2>8. SMS Communications</h2>
          <p>
            If you provide your phone number and consent to receive SMS messages,
            we may send messages for account verification, OTP, security, or account
            activity purposes. Message and data rates may apply. You may reply STOP
            to opt out or HELP for assistance where supported.
          </p>
        </section>

        <section>
          <h2>9. Children’s Privacy</h2>
          <p>
            Our services are intended for business users and are not directed to
            children under the age of 13. We do not knowingly collect personal
            information from children.
          </p>
        </section>

        <section>
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. Updates will be
            posted on this page with a revised effective date.
          </p>
        </section>

        <section className="legal-contact-card">
          <h2>11. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact us:</p>
          <p>
            <strong>Company:</strong> PayWeek Inc.
            <br />
            <strong>Website:</strong>{" "}
            <a href="https://www.payweek.com" target="_blank" rel="noopener noreferrer">
              www.payweek.com
            </a>
          </p>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;